import { PostAttachmentType } from '__generated__/graphql/legacy/graphql';
import {
  ACCEPTED_FILE_TYPES,
  ACCEPTED_IMAGE_TYPES,
  MAX_FILE_SIZE_MB,
  MAX_FILES_ALLOWED,
} from './constants';

export const getFileType = (mimeType: string) => {
  const parts = mimeType.split('/');
  const fileType = parts[0];
  if (ACCEPTED_IMAGE_TYPES.includes(fileType)) {
    return PostAttachmentType.Image;
  }
  return PostAttachmentType.File;
};

export const getFileExtension = (fileName?: string) => {
  if (!fileName) return '';
  const parts = fileName.split('.');
  return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
};

export const validateFiles = (
  files: File[],
  attachmentsLength: number
): string | null => {
  const maxFileSizeInBytes = MAX_FILE_SIZE_MB * 1024 * 1024;
  const fileTypeRegex = ACCEPTED_FILE_TYPES.replace(/,/g, '|').replace(
    '*',
    '.*'
  );

  if (files.length + attachmentsLength > MAX_FILES_ALLOWED) {
    return `You can only upload up to ${MAX_FILES_ALLOWED} files.`;
  }

  for (const file of files) {
    if (file.size > maxFileSizeInBytes) {
      return `File ${file.name} is too large. Maximum file size is ${MAX_FILE_SIZE_MB}MB.`;
    }

    if (!file.type.match(fileTypeRegex)) {
      return `File ${file.name} (${
        file.type
      }) is not accepted. Must be one of the following: ${ACCEPTED_FILE_TYPES.replace(
        /,/g,
        ', '
      )}`;
    }
  }

  return null;
};
